export default function insertScript ({ src, callback, pass = false }: {
    src: string;
    callback?: Function;
    pass: boolean;
}) {
    return new Promise((resolve, reject) => {
        if (pass) {
            resolve();
            if (callback) {
                setTimeout(callback, 0);
            }
        } else {
            let script = document.createElement('script');
            script.setAttribute('src', src);

            document.head.appendChild(script);
            script.onload = () => {
                resolve();
                if (callback) {
                    callback();
                }
            };
            script.onerror = reject;
        }
    });
}
